import BaseVue from '@/base/BaseVue';
import Http from '@/http/Http';

export default class Menu extends BaseVue {
    height = window.innerHeight - 60;
    defaultActive: any = null;
    menu: any[] = [
        {
            title: '信息管理',
            item: [
                {
                    url: '/jingling/manager',
                    title: '精灵管理'
                },
                {
                    url: '/jingdian/manager',
                    title: '景点管理'
                },
                // {
                //     url: '/order/manager',
                //     title: '兑换记录'
                // },
                // {
                //     url: '/system/manager',
                //     title: '系统配置'
                // },
            ]
        },
        {
            title: '用户管理',
            item: [
                {
                    url: '/user/usermanager',
                    title: '用户列表'
                },
                {
                    url: '/user/self',
                    title: '个人中心'
                },
            ]
        },
    ];

    mounted() {

        this.$router.afterEach((to, from) => {
            this.defaultActive = to.path;
        });
    }
}
